export default __webpack_public_path__ + "static/media/aampl.bc1b74fc.svg";